import CustomFileInput from "./CustomFileInput";

export default CustomFileInput;
